import { pickBy } from 'lodash-es'
import type { GetNextPageParamFunction } from '@tanstack/vue-query'
import type { PaginatedData } from '@lib/types/paginatedData'

export const DEFAULT_ITEMS_PER_PAGE = 15

export const getDefinedProps = <T extends object>(props: T): Partial<T> =>
  pickBy(props, (value) => value !== undefined && value !== '')

export const getNextPageParam: GetNextPageParamFunction<PaginatedData<any>> = (lastPage, pages): number | undefined => {
  if (pages.length === 0) return 0

  const total = pages[0].count
  const loadedItems = pages.flatMap((f) => f.results).length

  if (loadedItems < total) {
    return pages.length + 1
  }

  return undefined
}
